import axios from "../axios/axios";
import * as SKU_END_POINTS from "../constants/endpoints/sku";

export const getSkuCategories = () => {
  return axios({
    url: SKU_END_POINTS.GET_SKU_CATEGORIES,
    method: "GET",
  });
};

export const getSkuDetails = (skuId) => {
  return axios({
    url: SKU_END_POINTS.GET_SKU_DETAILS.replace(":skuId", skuId),
    method: "GET",
  });
};

export const getSkuSubcategories = (categoryId) => {
  return axios({
    url: SKU_END_POINTS.GET_SKU_SUBCATEGORIES.replace(
      ":categoryId",
      categoryId
    ),
    method: "GET",
  });
};

export const getSkus = (
  pageNumber,
  pageLimit,
  categoryId,
  subcategoryId,
  commercialName,
  skuBrands,
  carBrands,
  carModels,
  carTransmissionsAndCCs,
  carYearList,
  skuNames,
  skuIds
) => {
  return axios({
    url: SKU_END_POINTS.GET_SKUS,
    method: "GET",
    params: {
      offset: pageNumber,
      limit: pageLimit,
      skuCategoryId: categoryId || null,
      skuSubCategoryId: subcategoryId || null,
      skuCommercialName: commercialName || null,
      skuBrandIdList: skuBrands || null,
      carBrandIdList: carBrands || null,
      carModelIdList: carModels || null,
      carTransmissionAndCCList: carTransmissionsAndCCs || null,
      carYearList: carYearList || null,
      skuNameIdList: skuNames || null,
      skuIdList: skuIds || null,
    },
  });
};

export const getNewSkus = () => {
  return axios({
    url: SKU_END_POINTS.GET_NEW_SKUS,
    method: "GET",
  });
};

export const getRecommendedSkus = () => {
  return axios({
    url: SKU_END_POINTS.GET_RECOMMENDED_SKUS,
    method: "GET",
  });
};

export const getRelevantSkus = (skuId) => {
  return axios({
    url: SKU_END_POINTS.GET_RELEVANT_SKUS.replace(":skuId", skuId),
    method: "GET",
  });
};

export const getSubstituteSkus = (skuId) => {
  return axios({
    url: SKU_END_POINTS.GET_SUBSTITUTE_SKUS.replace(":skuId", skuId),
    method: "GET",
  });
};

export const getSkuBrands = (categoryId, subcategoryId) => {
  return axios({
    url: SKU_END_POINTS.GET_SKU_BRANDS,
    method: "GET",
    params: {
      skuCategoryId: categoryId || null,
      skuSubCategoryId: subcategoryId || null,
    },
  });
};

export const checkSkusMatchingCar = (skuIdList, carId) => {
  return axios({
    url: SKU_END_POINTS.checkSkusMatchingCar,
    method: "POST",
    data: { carId, skuIdList },
  });
};

export function logOutOfStock(skuId) {
  return axios({
    url: SKU_END_POINTS.LOG_OUT_OF_STOCK,
    method: "POST",
    data: { skuId },
  });
}

export function logSkuOutOfStockQuantity(skuId, quantity) {
  return axios({
    url: SKU_END_POINTS.LOG_SKU_OUT_OF_STOCK_QUANTITY,
    method: "POST",
    data: { skuId, quantity },
  });
}
